import React from 'react';
import WithSeparator from 'react-with-separator';

import HorizontalRuler from 'components/HorizontalRuler';
import { NewTemplate } from 'types/Template';
import SectionPreview from './SectionPreview';
import ZeroState from './ZeroState';
import { Action } from 'state';

interface HcsPreviewerProps {
  template: NewTemplate;
  dispatch: (action: Action) => void;
}

const HcsPreviewer: React.FC<HcsPreviewerProps> = ({ template, dispatch }) => {
  return (
    <WithSeparator separator={<HorizontalRuler />}>
      {template.exam_sections.map((section) => (
        <SectionPreview section={section} dispatch={dispatch} key={section.uuid} />
      ))}
      {template.exam_sections.length === 0 && <ZeroState />}
    </WithSeparator>
  );
};

export default HcsPreviewer;
